// src/pages/Siniestros/SiniestroLogsViewGrid.js
import SiniestroLogsCompGrid from 'components/Siniestros/SiniestroLogsCompGrid'
import useFetch from 'hooks/useFetch'
import { useEffect } from 'react'

export default function SiniestroLogsViewGrid() {
  const [fetched, fetchAll] = useFetch()

  const handleRefresh = async () => {
    await fetchAll({
      url: 'siniestros/logs/estado',
      method: 'GET',
      messageKo: '¡Error cargando historial de estados!'
    })
  }

  useEffect(() => {
    handleRefresh()
  }, [])

  // LOG TEMPORAL — bórralo cuando funcione
  console.log('fetched logs:', fetched)

  return (
    <SiniestroLogsCompGrid
      data={fetched?.data}
      handleRefresh={handleRefresh}
    />
  )
}